export default __webpack_public_path__ + "static/media/clipboard.9cbe50f9.svg";